package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.section
import react.PropsWithChildren

external interface PageBodyProps : PropsWithChildren

val PageBody = SFC<PageBodyProps> { props ->
    section("content") {
        +props.children
    }
}
